export type CommunityFilters = {
  gender: string
  age_range: string
  skill_level: string
  offers_private_lessons: boolean | null
  range: number | null
}

export const getCommunityFilterCount = (filters: CommunityFilters) =>
  [
    filters.gender,
    filters.age_range,
    filters.skill_level,
    filters.offers_private_lessons === true,
    filters.range !== null,
  ].filter(Boolean).length

export const hasActiveCommunityFilters = (filters: CommunityFilters) => getCommunityFilterCount(filters) > 0
